import { getTrip, getTripStops, getScheduledStudents, getUnScheduledStudents, getTripManifest, getTripSettings } from '@/apis/trip'

const state = {
    details: {},
    settings: {},
    stops: [],
    scheduledStudents: [],
    unScheduledStudents: [],
    manifest: {},
    pageKey: 'trip',
    pageName: 'Trip',
    // excludes: 'BusDetailsTracks'
}
// Only for trip details
const mutations = {
    SET_DETAILS: (state, details) => {
        state.details = details
    },
    SET_STOPS: (state, stops) => {
        state.stops = stops
    },
    SET_SCHEDULED_STUDENTS: (state, scheduledStudents) => {
        state.scheduledStudents = scheduledStudents
    },
    SET_UNSCHEDULED_STUDENTS: (state, unScheduledStudents) => {
        state.unScheduledStudents = unScheduledStudents
    },
    SET_SETTINGS: (state, settings) => {
        state.settings = settings
    },
    SET_MANIFEST: (state, manifest) => {
        state.manifest = manifest
    },
    REMOVE_ALL_DETAILS: (state) => {
        state.details = {}
        state.stops = []
        state.scheduledStudents = []
        state.unScheduledStudents = []
        state.manifest = {}
        state.settings = {}
    },
    UPDATA_TRIP_LATEST_STATUS(state, {trip_status, ontime_status, current_stop_id, next_stop_id}) {
        console.log('UPDATA_TRIP_LATEST_STATUS', {trip_status, ontime_status, current_stop_id, next_stop_id})
        if(trip_status !== undefined) {
            state.details.state.status = trip_status
        }
        if(ontime_status !== undefined) {
            state.details.state.ontime_status = ontime_status
        }
        if(current_stop_id !== undefined) {
            state.details.state.current_stop_id = current_stop_id
        }
        if(next_stop_id !== undefined) {
            state.details.state.next_stop_id = next_stop_id
        }
        if(next_stop_id !== undefined) {
            state.details.state.next_stop_id = next_stop_id
        }
    },
}

const actions = {
    getDetails({ commit }, id) {
        return new Promise((resolve, reject) => {
            getTrip(id).then(res => {
                const { data } = res
                commit('SET_DETAILS', data)
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    },
    getStops({ commit }, id) {
        return new Promise((resolve, reject) => {
            getTripStops(id).then(res => {
                const { data } = res
                commit('SET_STOPS', data)
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    },
    getScheduledStudents({ commit }, id) {
        return new Promise((resolve, reject) => {
            getScheduledStudents(id).then(res => {
                const { data } = res
                commit('SET_SCHEDULED_STUDENTS', data)
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    },
    getUnScheduledStudents({ commit }, id) {
        return new Promise((resolve, reject) => {
            getUnScheduledStudents(id).then(res => {
                const { data } = res
                commit('SET_UNSCHEDULED_STUDENTS', data)
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    },
    getSettings({ commit }, id) {
        return new Promise((resolve, reject) => {
            getTripSettings(id).then(res => {
                const { data } = res
                commit('SET_SETTINGS', data)
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    },
    getManifest({ commit }, id) {
        return new Promise((resolve, reject) => {
            getTripManifest(id).then(res => {
                const { data } = res
                commit('SET_MANIFEST', data)
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}